import { render, staticRenderFns } from "./Lavorazioni.vue?vue&type=template&id=031c899b"
import script from "./Lavorazioni.vue?vue&type=script&lang=js"
export * from "./Lavorazioni.vue?vue&type=script&lang=js"
import style0 from "./Lavorazioni.vue?vue&type=style&index=0&id=031c899b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports